export const DAILY_SESSION_DAY_KEY = "dailySessionDay";

export const getChronoscorePointsForGuessCount = (guessCount) => {
  if (!Number.isFinite(guessCount) || guessCount <= 0) return 0;
  if (guessCount === 1) return 40;
  if (guessCount === 2) return 30;
  if (guessCount === 3) return 20;
  if (guessCount === 4) return 10;
  return 0;
};

export const getGuessCountLabel = (guessCount, chronoscore) => {
  if (Number.isFinite(guessCount) && guessCount > 0) {
    return `${guessCount} ${guessCount === 1 ? "Guess" : "Guesses"}`;
  }

  if (chronoscore === 40) return "1 Guess";
  if (chronoscore === 30) return "2 Guesses";
  if (chronoscore === 20) return "3 Guesses";
  if (chronoscore === 10) return "4 Guesses";
  return "5+ Guesses";
};

export const resolveGuessCount = (guessCount, chronoscore) => {
  if (Number.isFinite(guessCount) && guessCount > 0) {
    return guessCount;
  }

  if (chronoscore === 40) return 1;
  if (chronoscore === 30) return 2;
  if (chronoscore === 20) return 3;
  if (chronoscore === 10) return 4;
  return 5;
};

export const resolveChronoscore = (chronoscore, guessCount) => {
  if (Number.isFinite(chronoscore) && chronoscore > 0) {
    return chronoscore;
  }

  return getChronoscorePointsForGuessCount(guessCount);
};

export const markDailySessionStarted = (currentDay) => {
  if (!currentDay) return;
  localStorage.setItem(DAILY_SESSION_DAY_KEY, String(currentDay));
};

export const hasCurrentDailySession = (currentDay) => {
  if (!currentDay) return false;
  return localStorage.getItem(DAILY_SESSION_DAY_KEY) === String(currentDay);
};

export const clearDailySessionStarted = () => {
  localStorage.removeItem(DAILY_SESSION_DAY_KEY);
};
